
import React from "react";
import { FiMapPin, FiHeart, FiTarget, FiHome, FiBriefcase } from "react-icons/fi";

const About = () => {
  return (
    <div className="bg-white">
      {/* HERO */}
      <section className="relative w-full overflow-hidden">
        <div className="relative w-full h-[360px] md:h-[420px] flex">
          <div
            className="relative z-10 flex items-center text-white"
            style={{
              width: "55%",
              backgroundColor: "#e11d7b",
              clipPath: "polygon(0 0, 100% 0, 92% 35%, 78% 100%, 0 100%)"
            }}
          >
            <div className="max-w-xl pl-8 md:pl-16 pr-10">
              <h1 className="text-4xl md:text-5xl font-extrabold leading-tight">
                À propos de Maxula
              </h1>
              <p className="mt-4 text-base md:text-lg text-white/90">
                Le trait d’union entre les opportunités et ceux qui croient au Maroc
              </p>
            </div>
          </div>

          <div
            className="absolute right-0 top-0 h-full w-full"
            style={{
              background:
                "linear-gradient(to right, #e11d7b 0%, rgba(225,29,123,0.5) 45%, rgba(225,29,123,0.15) 70%, transparent 100%)"
            }}
          />
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-14">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="bg-white border rounded-2xl p-6 leading-relaxed text-gray-700">
            <p className="font-medium text-gray-900">
              Tunisien de naissance mais Marocain de cœur, le fondateur de Maxula – ancien président du Rotary Club Casablanca – réside à Tanger, tout en partageant son temps avec Lausanne, en Suisse.
            </p>
            <p className="mt-4">
              Très tôt, il a développé une forte culture du service, du contact humain et de la confiance. Passionné par l’entrepreneuriat et la création de valeur, il s’est orienté vers le commerce, les relations humaines et la construction de projets.
            </p>
            <p className="mt-4">
              C’est avec respect et gratitude qu’il a choisi de développer Maxula sur la terre bénie du Royaume du Maroc : un pays d’accueil, de stabilité et de vision.
            </p>
          </div>

          {/* HOMMAGE */}
          <div className="bg-pink-50 border-l-4 border-[#e11d7b] rounded-xl p-6">
            <h2 className="text-xl font-bold text-[#e11d7b] mb-3">👑 Hommage à Sa Majesté le Roi Mohammed VI</h2>
            <p className="text-gray-700">
              Sous la conduite éclairée de Sa Majesté le Roi Mohammed VI – que Dieu Le glorifie –, le Maroc s’impose comme un modèle régional de développement et d’ouverture.
            </p>
            <ul className="list-disc list-inside mt-3 text-gray-700">
              <li>Organisation de la CAN 2025</li>
              <li>Participation historique à la Coupe du Monde 2030</li>
            </ul>
          </div>

          {/* A PROPOS */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white border rounded-2xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                <FiBriefcase className="text-[#e11d7b]" /> À propos de Maxula
              </h3>
              <p className="text-gray-700">
                Depuis plus de dix ans, Maxula – basée à Tanger – agit comme une agence multiservices et un intermédiaire de confiance pour investisseurs, professionnels et particuliers marocains et étrangers.
              </p>
            </div>

            <div className="bg-white border rounded-2xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                <FiTarget className="text-[#e11d7b]" /> Notre mission
              </h3>
              <p className="text-gray-700">
                Accompagner celles et ceux qui croient en l’avenir du Maroc en leur offrant un accès à un écosystème fiable, transparent et en pleine croissance.
              </p>
            </div>
          </div>

          {/* EXPERTISE */}
          <div className="bg-white border rounded-2xl p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Nos domaines d’expertise</h3>
            <ul className="grid sm:grid-cols-2 gap-3 text-gray-700">
              <li>🏠 Immobilier & accompagnement des expatriés</li>
              <li>🧖‍♂ Bien‑être & lifestyle</li>
              <li>💳 Offres & bons plans avec réservation</li>
              <li>🛒 E‑commerce & expériences digitales</li>
              <li>🤝 Développement local & partenariats</li>
            </ul>
          </div>

          {/* VALEURS */}
          <div className="bg-pink-50 border rounded-2xl p-6">
            <h3 className="text-lg font-bold text-[#e11d7b] mb-3 flex items-center gap-2">
              <FiHeart /> Nos valeurs
            </h3>
            <ul className="list-disc list-inside text-gray-700">
              <li>Engagement envers le Maroc</li>
              <li>Soutien à l’économie locale</li>
              <li>Transparence et rigueur</li>
              <li>Fraternité maghrébine</li>
              <li>Humanité et professionnalisme</li>
            </ul>
          </div>

          {/* LEGAL */}
          <div className="bg-white border rounded-2xl p-6 text-sm text-gray-700">
            <h3 className="font-bold mb-2">⚖ Informations légales – Maxula S.A.R.L</h3>
            <p>RC : 75375 – ICE : 001588644000012</p>
            <p>Identifiant fiscal : 18766346 – Patente : 50489114</p>
            <p>Adhérent CGEM : N°12389 – CCIS Tanger : N°8177</p>
            <p className="mt-2 flex items-center gap-1">
              <FiMapPin /> Avenue Beethoven, Résidence Oumnia 1, Bureau 83, Tanger – Maroc
            </p>
          </div>

          <p className="text-center font-semibold text-gray-800">
            Vive le Maroc 🇲🇦 – Vive Sa Majesté le Roi Mohammed VI
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;
